module.exports = __webpack_public_path__ + "img/icon-no-more.abb8f055.png";